import {rootDomain} from '../../domain';
import {Profile, UserRole} from '../../types/auth';

export const domain = rootDomain.createDomain('Utils');
export const setMainRole = domain.createEvent<UserRole | null>();
export const $mainRole = domain.createStore<UserRole | null>(null);

export const setProfile = domain.createEvent<Profile | null>();
export const $profile = domain.createStore<Profile | null>(null);

export const setIsNG = domain.createEvent<boolean>();
export const $isNG = domain.createStore<boolean>(false);
